import { useSelector } from "react-redux";
import { useMemo } from "react";
import { Box, Typography } from "@mui/material"
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import BaseLink from "../BaseLink"
import BaseButton from "../BaseButton";
// import BaseImage from "../../BaseImage";

import heart from "../../assets/images/reports-icons/Heart.svg";
import medicine from "../../assets/images/reports-icons/Pill.svg";
import dna from "../../assets/images/reports-icons/Dna.svg";
import nutrition from "../../assets/images/reports-icons/Apple.svg";
// import ImgNothing from "../../assets/images/confirm-images/img-nothing.png"
// import IconWarning from "../../Icons/warning";
import IconBrainMemory from '../../assets/images/icons/icon-brain-memory.svg'
// import IconBloodDisorder from '../../../assets/images/icons/icon-blood-disorder.svg'
// import IconInhearitedDisease from '../../../assets/images/icons/icon-inhearited-disease.svg'
import IconImmune from '../../assets/images/icons/icon-immune.svg'
// import IconSkin from '../../../assets/images/icons/icon-skin.svg'
import IconGeneralBodySystems from '../../assets/images/icons/icon-general-body-systems.svg'
// import IconMuscleBone from '../../../assets/images/icons/icon-bone-muscle.svg'
import IconLipids from '../../assets/images/icons/icon-lipids.svg'

export const DEMO_REPORTS = [
  {
    name: "Heart",
    value: "Heart",
    date: "09/03/2022",
    priority: 1,
    color: "#E73E3E",
    icon: heart,
    link: '/report/Heart'
  },
  {
    name: "Nutrition",
    value: "Nutrition",
    date: "05/02/2022",
    priority: 3,
    color: "#39B195",
    icon: nutrition,
    link: '/nutrition-report'
  },
  {
    name: "Hereditary Cancer",
    value: "Hereditary Cancer",
    date: "03/02/2022",
    priority: 3,
    color: "#FFCF54",
    icon: dna,
    link: '/report/Hereditary Cancer'
  },
  {
    name: "Medications",
    date: "05/02/2022",
    value: "Medications",
    priority: 3,
    color: "#39B195",
    icon: medicine,
    link: '/medication-report'
  },
  // {
  //   name: "Inherited Disease",
  //   date: "03/02/2022",
  //   priority: 3,
  //   color: "#39B195",
  //   icon: IconInhearitedDisease,
  //   link: '/'
  // },
  // {
  //   name: "Deep Heart",
  //   date: "03/02/2022",
  //   priority: 3,
  //   color: "#39B195",
  //   icon: heart,
  //   link: '/deep-heart'
  // },
  {
    name: "Brain & Memory",
    value: "Brain & Memory",
    date: "03/02/2022",
    priority: 0,
    color: "#39B195",
    icon: IconBrainMemory,
    link: '/report/Brain & Memory'
  },
  // {
  //   name: "Blood Disorders",
  //   date: "03/02/2022",
  //   priority: 0,
  //   color: "#39B195",
  //   icon: IconBloodDisorder,
  //   link: '/report/Blood Disorders'
  // },
  {
    name: "Immune",
    date: "03/02/2022",
    value: "Immune",
    priority: 0,
    color: "#39B195",
    icon: IconImmune,
    link: '/report/Immune'
  },
  // {
  //   name: "Skin",
  //   date: "03/02/2022",
  //   priority: 0,
  //   color: "#39B195",
  //   icon: IconSkin,
  //   link: '/report/Skin'
  // },
  {
    name: "ACMG Actionable",
    value: "General Actionable Results",
    date: "03/02/2022",
    priority: 0,
    color: "#39B195",
    icon: IconGeneralBodySystems,
    link: '/report/General Actionable Results'
  },
  // {
  //   name: "Muscle & Bone",
  //   date: "03/02/2022",
  //   priority: 0,
  //   color: "#39B195",
  //   icon: IconMuscleBone,
  //   link: '/report/Muscle & Bone'
  // },
  {
    name: "Lipids",
    value: "Lipids",
    date: "03/02/2022",
    priority: 0,
    color: "#39B195",
    icon: IconLipids,
    link: '/report/Lipids'
  },
];

const SectionHealthReport = () => {
  const auth = useSelector(state => state.auth)
  // const reports = useSelector(state => state.reports)
  
  const lastKitId = useMemo(() => {
    if (auth?.kits && auth?.kits?.length > 0) {
      return auth?.kits[auth?.kits?.length - 1]?.id.replace('Kit:', '')
    }
    return 'XXXXXXXX'
  }, [auth])

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'background.default',
        borderRadius: '24px',
        padding: '16px',
        bgcolor: 'white'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: '24px'
        }}
      >
        <Typography
          variant="h2"
          color="primary.black"
        >
          My reports
        </Typography>
        
        <Box
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Typography variant="body" color='primary.darkBlue'>
            Kit ID: {lastKitId}
          </Typography>
          {/* <BaseLink to='/reports'>
            <BaseButton
              buttonType={'primary'}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Typography
                  variant="body"
                  color="primary.white"
                  sx={{
                    whiteSpace: 'nowrap'
                  }}
                >
                  View all reports
                </Typography>
                <ChevronRightIcon 
                  sx={{
                    ml: '20px',
                    color: 'white'
                  }}
                />
              </Box>
            </BaseButton>
          </BaseLink> */}
        </Box>
      </Box>
      <Box
        sx={{
          mb: '24px'
        }}
      >
        <Typography variant="body">
          Our reports come from the widest genome scan possible that covers your whole genome. Over 90,000 genes, which also includes analysis of variants unique to you. {' '} 
          <BaseLink 
            to={'/'} 
            sx={{
              color: 'primary.darkBlue',
              textDecoration: 'underline !important',
              fontStyle: 'italic'
            }}
          >Learn more</BaseLink>
        </Typography>
      </Box>
      
      <Box
        sx={{
          display: { md: 'none' },
          mt: '24px'
        }}
      >
        <BaseLink to='/reports'>
          <BaseButton
            buttonType={'primary'}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Typography
                variant="body"
                color="primary.white"
              >
                View all reports
              </Typography>
              {/* <ChevronRightIcon 
                sx={{
                  ml: '20px',
                  color: 'white'
                }}
              /> */}
            </Box>
          </BaseButton>
        </BaseLink>
      </Box>
    </Box>
  )
}

export default SectionHealthReport